import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { deletepayslip, listpayslip } from "../../../services/admin";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import exportUrl from "../../../exportUrl";

export default function Allpayslip() {
    const [filterProduct, setFilterProduct] = useState([]);
    const navigate = useNavigate();

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 140,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            width: 180,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a onClick={() => navigate(`/payslip/payslipreport/${params.value}`)}
                            className="btn-sm btn-primary me-2"
                            title="View / Print Payslip"
                        >
                            <i className="fa fa-print"></i>
                        </a>
                        {localStorage.getItem("Role") == 1 &&
                            <>
                                <a onClick={() => navigate(`/payslip/payslipdetail/${params.value}`)}
                                    className="btn-sm btn-info me-2"
                                    title="Payslip Detail"
                                >
                                    <i className="fa fa-edit"></i>
                                </a>
                                <a onClick={() => handleSwitch(params.value)}
                                    className="btn-sm btn-danger me-2"
                                    title="Delete Payslip"
                                >
                                    <i className="fa fa-trash"></i>
                                </a>
                            </>
                        }
                    </div>
                );
            },
        },
        {
            headerName: "Staff Name",
            field: "staff_name",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Staff Code",
            field: "staff_code",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Month",
            field: "month",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Year",
            field: "year",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Pay Date",
            field: "pay_date",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return (
                        moment(params.value).format("DD-MM-YYYY")
                    );
                }
            }
        },
        {
            headerName: "Gross",
            field: "gross_salary",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "PF",
            field: "pf",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "ESI",
            field: "esi",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "PT",
            field: "pt",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Total Deduction",
            field: "total_deduction",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Net Salary",
            field: "net_salary",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
    ];

    useEffect(() => {
        funlist();

    }, []);

    function funlist() {
        setFilterProduct([]);
        listpayslip(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data.details);
            }
        });
    }

    function downloadfile(dtype) {
        const params =
            "branch=" + (localStorage.getItem("branch") || "") +
            "&type=" + dtype;
        window.open(exportUrl + "report/payslipdownload?" + params, "_blank");
    }

    function handleSwitch(lid) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {

                deletepayslip(lid).then((response) => {
                    if (response.status === true) {
                        funlist();
                    }
                });
            }
        });

    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">All Payslip</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Payslip</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        All Payslip
                    </li>
                </ol>

            </div>


            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    All Payslip Detail
                                </h2>
                                <div>
                                    <a className="btn btn-danger me-2" onClick={() => downloadfile("pdf")}>Download PDF</a>
                                    <a className="btn btn-success" onClick={() => downloadfile("excel")}>Download Excel</a>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={filterProduct}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
